module.exports = __webpack_public_path__ + "media/images/frontend/down-w-0a0d10dba9eb9774fbf6bebdf8c32bdf.svg";